<template>
  <div class="d-flex flex-column flex-grow-1">
    <v-data-table
      ref="dataTable"
      must-sort
      class="pa-3 px-sm-5"
      :class="{
        'full-height-table pagination-on-top flex-grow-1 pt-0 ': !isMobile,
        'mobile-table': isMobile,
      }"
      fixed-header
      sort-by="name"
      item-key="key"
      :headers="headers"
      :items="keyedItems"
      :footer-props="footerProps"
      :items-per-page.sync="itemsPerPage"
      :page.sync="currentPage"
      @update:sort-by="scrollTabletoTop"
      @update:sort-desc="scrollTabletoTop"
      @update:page="scrollTabletoTop"
    >
      <template #item.name="{ item }">
        <span class="notranslate">{{ item.name }} </span>
      </template>
      <template #item.templateType="{ item }">
        {{ getTemplateTypeName(item.templateType) }}
      </template>
      <template #item.locale="{ item }">
        {{ getTemplateLocaleName(item.locale) }}
      </template>
      <template #item.action="{ item }">
        <v-btn icon @click.stop="$emit('edit-template', item)">
          <v-tooltip top color="primary">
            <template #activator="{ on }">
              <v-icon color="primary" dark v-on="on">
                {{ userHasAdminRights ? "$edit" : "$eye" }}</v-icon
              >
            </template>
            <span>{{ userHasAdminRights ? $t("edit") : $t("preview") }}</span>
          </v-tooltip>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataTableDefaults from "@/mixins/dataTableDefaults";
import emailTemplateNames from "@/mixins/emailTemplateNames";

export default {
  name: "EmailTemplatesOverview",
  mixins: [dataTableDefaults, emailTemplateNames],
  props: {
    userHasAdminRights: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      sortBy: "name",
      descending: false,
    };
  },
  computed: {
    keyedItems() {
      if (!this.currentHotel) {
        return [];
      }
      return this.currentHotel.templates.map((item) => ({
        key: item.name + "_" + item.locale + "_" + item.templateType,
        ...item,
      }));
    },

    headers() {
      const headers = [
        {
          text: this.$t("name"),
          value: "name",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("type"),
          value: "templateType",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("language"),
          value: "locale",
          divider: true,
          sortable: true,
        },
      ];
      if (this.$vuetify.breakpoint.lgAndUp) {
        headers.push({
          text: this.$t("actions"),
          value: "action",
          divider: true,
          sortable: false,
          width: 80,
        });
      }
      return headers;
    },
    ...mapState(["currentHotel"]),
  },
};
</script>
